import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { defaultCornerRadii } from '@bubble-ui/particle-default-corner-radii';
import { defaultColorVariables } from '@bubble-ui/particle-default-color-variables';
import { defaultTextStyles } from '@bubble-ui/particle-default-text-styles';
import { sizeTokenFromNestedArguments, referenceForwardArgs, textStyleTokenFromNestedArguments } from '@klarna/designtokens';
var avatarBorderRadius = {
  square: (tokenResolver, args) => tokenResolver('corner-radius/xs', args),
  default: (tokenResolver, args) => tokenResolver('corner-radius/round', args)
};
var avatarTextStyle = {
  small: tokenResolver => tokenResolver('text-style/text/paragraphs/tiny/bold', {}),
  medium: tokenResolver => tokenResolver('text-style/text/paragraphs/body/bold', {}),
  large: tokenResolver => tokenResolver('text-style/text/paragraphs/grande/bold', {}),
  default: tokenResolver => tokenResolver('text-style/text/paragraphs/tall/bold', {})
};
var avatarImageSize = {
  large: 72,
  medium: 40,
  small: 32,
  default: 48
};
export var defaultComponentTokens = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, defaultColorVariables), defaultCornerRadii), defaultTextStyles), {}, {
  'avatar/amount-background-color': referenceForwardArgs('colors/backgrounds/neutral'),
  'avatar/amount-text-color': referenceForwardArgs('colors/text/inverse'),
  'avatar/corner-radius': sizeTokenFromNestedArguments(avatarBorderRadius, ['borderRadiusType']),
  'avatar/image-size': sizeTokenFromNestedArguments(avatarImageSize, ['size']),
  'avatar/border-color': referenceForwardArgs('colors/borders/default'),
  'avatar/background-color': referenceForwardArgs('colors/backgrounds/subtle-floating'),
  'avatar/text-color': referenceForwardArgs('colors/text/subtle'),
  'avatar/text-style': textStyleTokenFromNestedArguments(avatarTextStyle, ['size'])
});
//# sourceMappingURL=defaultComponentTokens.js.map